/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import * as PropTypes from "prop-types";
import PaymentSummary from "./PaymentSummary";
import { useSelector } from "react-redux";
import { paymentOptions } from "../../../../../utils/constants";
import AppBankList from "../../../../../components/AppBankList";
import PaymentForm from "../../../../../components/PaymentForm";

export default function ClearJunction(props) {
  const { amount, setActive, active, mode, country, currency, setIsConflict, fiatOption, destinationRecord} = props;
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);

  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);
  const [bank, setBank] = useState(null);
  const bankFlag = useSelector(({ transfer }) => transfer.connectBank);
  if (bankList?.length === 0 || bankFlag) {

    if (active === 3) {
      return (
        <PaymentForm
          active={active}
          submitFlag={fiatService?.serviceName === paymentOptions?.["type-2"]}
          setActive={setActive}
          country={country}
          currency={currency}
          mode={mode}
          setBank={setBank}
          setIsConflict={setIsConflict}
          fiatOption={fiatOption}
          destinationRecord={destinationRecord}
        />
      );
    }
  } else {
    if (active === 2) {
      return (
        <AppBankList
          active={active}
          setActive={setActive}
          bankList={bankList}
          bank={bank}
          mode={mode}
          setBank={setBank}
        />
      );
    }
  }
  if (active === 4) {
    return  <PaymentSummary active={active} amount={amount} setActive={setActive} bank={bank} paymentCurrency={(bank?.currency).toUpperCase()} setIsConflict={setIsConflict} country={country}/>
  }
}

ClearJunction.propTypes = {
  amount: PropTypes.any,
  setActive: PropTypes.func,
  active: PropTypes.number,
};
